<div class="login-page">
  <div class="login-wrapper">
    <mat-card class="login-card">
      <div class="login-logo-wrapper">
        <img [src]="themeService.currentTheme() === 'dark' ? '/logo-dark.png' : '/logo.png'" alt="copago Logo"
          class="login-logo" />
      </div>

      <div class="login-header">
        <h1>Filialverwaltung</h1>
        <p>Melden Sie sich an</p>
      </div>

      <form class="login-form" [formGroup]="loginForm" (ngSubmit)="submit()" ngNativeValidate>
        <div class="form-field-group">
          <label for="username" class="custom-label">E-Mail oder Benutzername</label>

          <mat-form-field appearance="outline" class="full-width custom-field">
            <input id="username" matInput type="text" formControlName="username"
              placeholder="name@firma.de oder benutzername" autocomplete="username" required
              (input)="onUsernameInput($event)" (invalid)="onUsernameInvalid($event)" />
          </mat-form-field>
        </div>

        <div class="form-field-group">
          <label for="password" class="custom-label">Passwort</label>

          <mat-form-field appearance="outline" class="full-width custom-field">
            <input id="password" matInput [type]="hidePassword() ? 'password' : 'text'" formControlName="password"
              autocomplete="current-password" required />

            <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()"
              [attr.aria-label]="hidePassword() ? 'Passwort anzeigen' : 'Passwort verbergen'">
              <mat-icon>{{ hidePassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>
        </div>
        
        <div class="forgot-password-row">
          <a routerLink="/forgot-password">Passwort vergessen?</a>
        </div>
        @if (serverError()) {
        <div class="server-error">
          {{ serverError() }}
        </div>
        }

        <button mat-flat-button type="submit" class="login-button" [disabled]="isSubmitting()">
          @if (!isSubmitting()) {
          <span>Anmelden</span>
          } @else {
          <mat-spinner diameter="20"></mat-spinner>
          }
        </button>
        @if (backendVersion()) {
        <div class="backend-version">
          Version: {{ backendVersion() }}
        </div>
        }
      </form>
    </mat-card>
  </div>
</div>